import {createBrowserHistory} from "history";

const customHistory = createBrowserHistory({"forceRefresh": true});
export default customHistory;


// npm install -D @types/history